import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-24 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
            常见问答
          </h2>
          <div className="w-12 h-1 bg-primary-500 rounded-full mx-auto mb-4"></div>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            快速了解麻花视频的使用方式
          </p>
        </div>

        <div className="max-w-3xl mx-auto grid grid-cols-1 gap-4">
          {faqData.map((item, i) => (
            <div
              key={i}
              className="rounded-2xl bg-background-50 border border-background-200/60 p-6"
            >
              <h3 className="text-base font-heading font-bold text-foreground-950 mb-3 flex items-start gap-3">
                <span className="w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-sm font-bold shrink-0 mt-0.5">
                  Q
                </span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}